<script lang="ts">
    import axios from 'axios';
    import Shgrid from '../shgrid/shgrid.svelte';
    import type { Column } from '@/components/shgrid';
    import type { Snippet } from 'svelte';

    type Row = {
        id: string;
        harness_number: string;
        lanyard_number: string | null;
        purchase_date: string | null;
        expiry_date: string | null;
        manufacturer: string | null;
        model: string | null;
        employee_id: string;
        latest_inspection: {
            id: string;
            inspection_date: string;
            fit_for_use: boolean;
        } | null;
    };

    type Props = {
        view: string;
        onRowClick?: (row: Row) => void;
        relatedData?: Record<string, any>;
        title?: string
        headerSnippet?: Snippet;
        id?: string;
        refetch?: () => Promise<void>;
    };

    let { view, onRowClick, relatedData, title = '', headerSnippet = null, id = '', refetch = $bindable() }: Props = $props();

    let cols = $state<Column<Row>[]>([
        {
            label: 'Harness #',
            key: 'harness_number',
            cellRender: {
                type: 'text',
                label: (row) => row.harness_number,
            },
            sortable: true,
            filter: {
                type: 'string',
            },
        },
        {
            label: 'Lanyard #',
            key: 'lanyard_number',
            cellRender: {
                type: 'text',
                label: (row) => row.lanyard_number ?? '-',
            },
            sortable: true,
            filter: {
                type: 'string',
            },
        },
        {
            label: 'Expiry Date',
            key: 'expiry_date',
            cellRender: {
                type: 'date',
                label: (row) => row.expiry_date,
            },
            sortable: true,
            filter: {
                type: 'date',
            },
        },
        {
            label: 'Last Inspection',
            key: 'latest_inspection',
            cellRender: {
                type: 'text',
                label: (row) => row.latest_inspection?.inspection_date ?? 'No inspections',
            },
            sortable: false,
            filter: {
                type: null,
            },
        },
        {
            label: 'Status',
            key: 'status',
            cellRender: {
                type: 'text',
                label: (row) => {
                    if (!row.latest_inspection) return 'Needs Inspection';
                    return row.latest_inspection.fit_for_use ? 'Fit for Use' : 'Defects Found';
                },
            },
            sortable: false,
            filter: {
                type: null,
            },
        },
    ]);
</script>

<div id={id}>
    <Shgrid
        fetcher={async ({ limit, offset, filters, sorter }) => {
            if (view === 'relatedList' && relatedData) {
                let relatedColumn = relatedData.column;
                let related_record_id = relatedData.record_id;
                filters = { ...filters, [relatedColumn]: related_record_id };
            }
            const res = await axios.get(route('web-api.Harness.index', { limit, offset, filters, sorter }));
            return { data: res.data, error: null };
        }}
        limit={100}
        bind:columns={cols}
        bind:refetch
        {...(onRowClick ? { onRowClick } : {})}
        {title}
        {headerSnippet}
    />
</div>
